import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import classNames from "classnames";
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
  useMemo,
} from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import {
  faEnvelope,
  faBuilding,
  faInfoCircle,
  faSearch,
  faSpinner,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  fetchCondominiumPeriodSelect,
  fetchAliquots,
  fetchPropertyPlanilla,
  fetchReports,
  sendEmail,
  sendEmailAdmin,
  fetchAutoPaySummary,
} from "../../helpers/api/finance";
import PropertyPlanillaReport from "./PropertyPlanillaReport";
import PlanillaBalanceTiles from "./PlanillaBalanceTiles";
import PeriodSelect from "../common/PeriodSelect";
import Datetime from "react-datetime";
import moment from "moment";
import { useSelector } from "react-redux";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import Logo from "../navbar/Logo";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
// eslint-disable-next-line import/no-named-as-default
import jsPDF from "jspdf";
import useSWRFetch from "../../helpers/hooks/useSWRFetch";
import { sortByExpenseDate } from "../../helpers/sortByExpenseDate";
import { findOneConfig } from "../../helpers/api/condominium";
import { showCurrency, findAllCurrencies } from "../../helpers/api/currency";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import SelectPropertyListItem from "../common/SelectPropertyListItem";
import FullPagination from "../common/pagination/FullPagination";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import Loader from "../common/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CurrencyContext } from "../../context/Context";
import {
  Link,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import { checkUserToken } from "../../helpers/api/auth";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import { getCurrencyName } from "../../helpers/currencyConversion";
import { formatPlanillaDate, planillaDueDate } from "../../helpers/planillaDates";

const Reports = () => {
  const moduleBase = useModuleBase();
  const reportRef = useRef();
  const { token } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { data: dataConfig, isLoading: loadingConfig } = useSWRFetch(
    selectedCondominium,
    findOneConfig
  );
  const { id } = useParams();
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const [periodId, setPeriodId] = useState();
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const [params, setParams] = useState({ start_date: null, end_date: null });

  // Fecha de la tasa con la que se convierten los montos a la moneda
  // secundaria. Arranca en hoy, que es lo que hacía la planilla antes de
  // HO-TASK-240, y el administrador puede moverla para ver el reporte a la
  // tasa que estaba vigente ese día. rateDateInput es lo que se ve en el
  // filtro; appliedRateDate es lo que se aplicó al pulsar "Buscar".
  const today = moment().format("YYYY-MM-DD");
  const [rateDateInput, setRateDateInput] = useState(today);
  const [appliedRateDate, setAppliedRateDate] = useState(today);
  const [isSearching, setIsSearching] = useState(false);

  // HO-TASK-246: si cada gasto de la planilla lleva su monto convertido a la
  // moneda secundaria. Apagado, la conversión queda solo en los totales, que
  // es lo que la mayoría de las juntas quiere ver. No se recuerda entre
  // sesiones: es una decisión de esta planilla, igual que el período o la
  // fecha de la tasa, y viaja tal cual a los correos que se envíen desde acá.
  const [showItemsInQuote, setShowItemsInQuote] = useState(false);
  const [showTotalsInQuote, setShowTotalsInQuote] = useState(true);

  const [reportTotals, setReportTotals] = useState(null);
  const [periodNote, setPeriodNote] = useState(null);
  const reportRate = reportTotals?.exchange_rate || null;
  const rateValue = Number(reportRate?.value || curr?.value || 0);
  const rateDateKey = reportRate?.date || null;
  const isExactDate = reportRate ? Boolean(reportRate.is_exact) : true;
  const isRateLoading = false;

  const [periodos, setPeriodos] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [paramsCurrency, setParamsCurrency] = useState({
    condominium_id: selectedCondominium,
  });
  const [userData, setUserData] = useState({});
  const [amount, setAmount] = useState(0);
  const [amountE, setAmountE] = useState(0);
  const [amountI, setAmountI] = useState(0);
  const [amountF, setAmountF] = useState(0);
  const [amountIncomesCommon, setAmountIncomesCommon] = useState(0);
  const [amountIncomesIndividual, setAmountIncomesIndividual] = useState(0);
  // HO-TASK-254: al imprimir se ocultan las pestañas "Condominio completo" /
  // "Por propietario" y el aviso "Mostrando cuentas de…", que llevan
  // d-print-none. La regla va explícita porque el tema no siempre incluye
  // esa utilidad de Bootstrap en la hoja que carga la pantalla.
  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
    pageStyle: "@media print { .d-print-none { display: none !important; } }",
  });
  const [error, setError] = useState(null);
  const [report, setReport] = useState([]);
  const [reportE, setReportE] = useState([]);
  const [reportI, setReportI] = useState([]);
  const [funds, setFunds] = useState([]);
  const [incomesCommon, setIncomesCommon] = useState([]);
  const [incomesIndividual, setIncomesIndividual] = useState([]);
  const [rawReport, setRawReport] = useState([]);
  const [rawReportE, setRawReportE] = useState([]);
  const [rawReportI, setRawReportI] = useState([]);
  const [rawFunds, setRawFunds] = useState([]);
  const [rawIncomes, setRawIncomes] = useState([]);
  const [viewMode, setViewMode] = useState("condominium");
  const [selectedAliquot, setSelectedAliquot] = useState(null);
  const [propertySearchInput, setPropertySearchInput] = useState("");
  const [aliquotsParams, setAliquotsParams] = useState({
    condominiumId: selectedCondominium,
    state: 0,
    search: "",
  });
  const {
    data: aliquotsList,
    isLoading: isLoadingAliquots,
    meta: aliquotsMeta,
    handler: {
      nextPage: aliquotsNextPage,
      previousPage: aliquotsPreviousPage,
      goToPage: aliquotsGoToPage,
      perPage: aliquotsPerPage,
    },
  } = useSWRFetchPagination(fetchAliquots, aliquotsParams, null, 1, 8);
  const appliedRateDateLabel = moment(appliedRateDate).format("DD MMM YYYY");
  const rateDateLabel = rateDateKey
    ? moment(rateDateKey).format("DD MMM YYYY")
    : null;
  // Solo se avisa cuando la tasa aplicada no es la de la fecha pedida: si no,
  // el reporte estaría mostrando bolívares de otro día sin decirlo.
  const rateFallbackNotice = isExactDate
    ? null
    : rateDateLabel
      ? `No hay tasa registrada para el ${appliedRateDateLabel}. Se aplica la del ${rateDateLabel}, que era la vigente ese día.`
      : `No hay tasa registrada para el ${appliedRateDateLabel}. Se aplica la tasa activa.`;

  // HO-TASK-253: la tasa de cada línea la resuelve el backend con la fecha del
  // gasto (`exchange_rate`, misma regla que el detalle de cuentas por pagar).
  // Antes se buscaba acá contra el catálogo de tasas y, si faltaba, se pedía
  // la de ese día a un servicio externo por cada fila. Sin tasa no hay
  // bolívares: cero hace que QuoteAmount muestre 0,00 en vez de inventar uno.
  const getRateForRow = (row) => Number(row?.exchange_rate?.value) || 0;

  // Ocupado = trayendo el reporte o resolviendo la tasa. La tasa puede tardar
  // porque, si no hay una registrada para la fecha, se consulta la oficial de
  // ese día contra un servicio externo.
  const isBusy = isSearching || isRateLoading;

  // Sin moneda secundaria o sin tasa no hay conversión que mostrar, así que
  // tampoco hay nada que elegir: el interruptor no se ofrece.
  const hasConversion = Boolean(curr?.currency?.iso) && rateValue > 0;

  /**
   * HO-TASK-246: la conversión de una línea de la planilla, debajo de su monto
   * en la moneda base.
   *
   * Debajo de cada gasto solo sale si el administrador lo pidió — un monto
   * convertido bajo cada línea llena la planilla de números que muchos no
   * quieren ver. Los totales (`isTotal`) la llevan siempre: es lo que hay que
   * pagar, y es el mínimo que la tarea exige mostrar en bolívares.
   *
   * Misma regla que la vista por propietario (PropertyPlanillaReport) y que el
   * correo (pay-notification.blade.php, `$isTotal || $showItemsInQuote`).
   *
   * `customRate` deja usar la tasa de la fecha de ese gasto en vez de la del
   * reporte, que es lo que corresponde línea por línea.
   */
  const QuoteAmount = ({ value, negative, isTotal, customRate, convertedValue }) =>
    hasConversion && (isTotal ? showTotalsInQuote : showItemsInQuote) ? (
      <span className="d-block text-700 fs--2 text-nowrap">
        <NumberFormat
          className="text-right text-nowrap"
          displayType="text"
          prefix={`${negative ? "- " : ""}${curr.currency.iso} `}
          allowedDecimalSeparators={true}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale
          value={convertedValue !== undefined ? convertedValue : (Number(value) || 0) * (customRate || rateValue)}
        />
      </span>
    ) : null;

  const isPropertyView = viewMode === "property" && Boolean(selectedAliquot);

  const sectionBs = (key, fallback) => {
    const source = isPropertyView ? reportTotals?.property_totals : reportTotals?.totals;
    const value = source?.[`${key}_bs`];
    return value !== undefined && value !== null ? Number(value) : fallback;
  };
  const backendTotal = (key) => {
    const source = isPropertyView ? reportTotals?.property_totals : reportTotals?.totals;
    const value = source?.[key];
    return value !== undefined && value !== null ? Number(value) : null;
  };
  const getConvertedTotal = (rows, baseSum, key) => {
    if (rows.length <= 0) return 0;
    const fallback = isPropertyView
      ? baseSum * rateValue
      : rows.reduce(
          (prev, next) =>
            prev +
            (next?.amount_converted !== undefined && next?.amount_converted !== null
              ? Number(next.amount_converted)
              : Number(getRateForRow(next) * next.amount)),
          0
        );
    return key ? sectionBs(key, fallback) : fallback;
  };

  const selectedPropertyId = selectedAliquot?.property?.id;
  const aliquotFactor = isPropertyView
    ? Number(selectedAliquot.value) / 100
    : 1;
  const [data, setData] = useState([]);
  const [propertyPlanilla, setPropertyPlanilla] = useState(null);
  const [isLoadingPlanilla, setIsLoadingPlanilla] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (!isPropertyView || !selectedPropertyId || !params.period_id) {
      setPropertyPlanilla(null);
      return undefined;
    }

    setIsLoadingPlanilla(true);

    fetchPropertyPlanilla(selectedPropertyId, {
      period_id: params.period_id,
      exchange_rate_date: appliedRateDate,
    })
      .then((response) => {
        if (isMounted) {
          setPropertyPlanilla(response?.planilla || null);
        }
      })
      .catch(() => {
        // Si falla se cae a la vista de siempre: una estimación es mejor que
        // una pantalla vacía.
        if (isMounted) setPropertyPlanilla(null);
      })
      .finally(() => {
        if (isMounted) setIsLoadingPlanilla(false);
      });

    return () => {
      isMounted = false;
    };
  }, [
    isPropertyView,
    selectedPropertyId,
    params.period_id,
    appliedRateDate,
  ]);

  // Un período que todavía no se emitió no tiene filas cobradas a la
  // propiedad: ahí no hay planilla que mostrar y se sigue con la
  // previsualización estimada de siempre.
  const planillaTables = propertyPlanilla?.tables;
  const hasRealPlanilla = Boolean(
    planillaTables &&
      ["ordinary", "extraordinary", "particular", "funds", "credits"].some(
        (key) => (planillaTables[key] || []).length > 0
      )
  );
  const fetchApireports = useCallback(async () => {
    if (!params.period_id) return;
    setIsSearching(true);
    try {
      const response = await fetchReports(selectedCondominium, {
        ...params,
        exchange_rate_date: appliedRateDate,
        property_id: isPropertyView ? selectedPropertyId : undefined,
      });
      const finances = response.finances || [];
      setReportTotals({
        totals: response.totals || null,
        property_totals: response.property_totals || null,
        exchange_rate: response.exchange_rate || null,
      });
      setPeriodNote(response.period_note ?? null);
      const getFinanceTypeId = (report) =>
        report?.finance?.type?.id ?? report?.type?.id;
      const financeType1Reports = finances.filter(
        (report) => getFinanceTypeId(report) === 1
      );
      const financeType2Reports = finances.filter(
        (report) => getFinanceTypeId(report) === 2
      );
      const financeType3Reports = finances.filter(
        (report) => getFinanceTypeId(report) === 3
      );
      setData(finances);
      setRawReport(sortByExpenseDate(financeType1Reports));
      setRawReportE(sortByExpenseDate(financeType2Reports));
      setRawReportI(sortByExpenseDate(financeType3Reports));
      setRawIncomes(response.incomes || []);
      // Los fondos salen de la misma respuesta: antes había un segundo
      // useCallback que volvía a pedir el mismo endpoint solo para esto.
      setRawFunds(response.reserveFundsPayments || []);
    } catch (error) {
      setRawReport([]);
      setRawReportE([]);
      setRawReportI([]);
      setRawIncomes([]);
      setRawFunds([]);
      setReportTotals(null);
    } finally {
      setIsSearching(false);
    }
  }, [params, appliedRateDate, isPropertyView, selectedPropertyId]);

  const handleSearchProperty = (value = propertySearchInput) => {
    const term = typeof value === "string" ? value.trim() : "";
    setPropertySearchInput(term);
    setAliquotsParams((previous) => ({
      ...previous,
      search: term,
    }));
    aliquotsGoToPage(1);
  };

  useEffect(() => {
    setAliquotsParams((previous) => ({
      ...previous,
      condominiumId: selectedCondominium,
    }));
  }, [selectedCondominium]);

  useEffect(() => {
    const matchesSelectedProperty = (item) =>
      item?.property_id === selectedPropertyId ||
      item?.property?.id === selectedPropertyId ||
      item?.property?.property_id === selectedPropertyId;
    const withTotal = (item) => ({
      ...item,
      total_amount: item?.amount,
      total_amount_converted: item?.amount_converted,
    });
    const scaleCommonAmount = (items) =>
      items.map((item) => ({
        ...withTotal(item),
        amount:
          item?.property_share !== undefined && item?.property_share !== null
            ? Number(item.property_share)
            : Number(item.amount) * aliquotFactor,
        amount_converted:
          item?.property_share_bs !== undefined && item?.property_share_bs !== null
            ? Number(item.property_share_bs)
            : undefined,
      }));
    const propertyReports = (items) =>
      items
        .map((item) => {
          const assignedProperties =
            item?.properties || item?.finance?.properties || [];
          const propertyEntry = assignedProperties.find(
            (entry) => entry?.property?.id === selectedPropertyId
          );
          if (propertyEntry) {
            return {
              ...withTotal(item),
              amount: Number(
                item?.property_share ?? propertyEntry.amount ?? propertyEntry.value ?? 0
              ),
              amount_converted:
                item?.property_share_bs !== undefined && item?.property_share_bs !== null
                  ? Number(item.property_share_bs)
                  : undefined,
            };
          }
          return matchesSelectedProperty(item) ? withTotal(item) : null;
        })
        .filter(Boolean);

    if (!isPropertyView) {
      setReport(rawReport);
      setReportE(rawReportE);
      setReportI(rawReportI);


      setFunds(rawFunds);
      setIncomesCommon(
        rawIncomes.filter((income) => Boolean(income.is_common_type))
      );
      setIncomesIndividual(
        rawIncomes.filter((income) => !income.is_common_type)
      );
      return;
    }

    setReport(scaleCommonAmount(rawReport));
    setReportE(scaleCommonAmount(rawReportE));
    setReportI(propertyReports(rawReportI));
    setFunds(scaleCommonAmount(rawFunds));
    setIncomesCommon(
      scaleCommonAmount(
        rawIncomes.filter((income) => Boolean(income.is_common_type))
      )
    );
    setIncomesIndividual(
      rawIncomes
        .filter((income) => !income.is_common_type)
        .filter(matchesSelectedProperty)
        .map(withTotal)
    );
  }, [
    rawReport,
    rawReportE,
    rawReportI,
    rawFunds,
    rawIncomes,
    isPropertyView,
    selectedPropertyId,
    aliquotFactor,
  ]);

  const [periods, setPeriods] = useState([]);
  const fetchApiPeriods = useCallback(async () => {
    try {
      const response = await fetchCondominiumPeriodSelect(selectedCondominium);
      setPeriods(
        response.data && response.data.length >= 0 ? response.data : []
      );
    } catch (error) {
      setPeriods([]);
    }
  }, []);

  const total = useMemo(() => {
    const fromBackend = backendTotal("total");
    if (fromBackend !== null) return fromBackend;
    const expenses = [+amountF, +amount, +amountE, +amountI].reduce((a,c)=>a+c,0);
    return Math.max(expenses-amountIncomesCommon-amountIncomesIndividual,0)
  }, [amountF, amount, amountE, amountI, amountIncomesCommon, amountIncomesIndividual, isPropertyView, reportTotals]);

  const chargedToOwners = !isPropertyView ? backendTotal("charged_to_owners") : null;
  const aliquotDifference = !isPropertyView ? backendTotal("aliquot_difference") ?? 0 : 0;
  const aliquotsSum = !isPropertyView ? backendTotal("aliquots_sum") : null;

  const convertedTotal = useMemo(() => {
    const fromBackend = sectionBs("total", null);
    if (fromBackend !== null) return fromBackend;
    if (isPropertyView) return total * (rateValue || 0);
    const expenses = [
      getConvertedTotal(report, amount, "ordinary"),
      getConvertedTotal(reportE, amountE, "extraordinary"),
      getConvertedTotal(reportI, amountI, "particular"),
      // Los fondos de reserva no nacen de un gasto: van con la tasa del día
      // elegido arriba, la misma del total a pagar.
      sectionBs("funds", Number(amountF) * (rateValue || 0))
    ].reduce((a,c) => a + c, 0);
    const incomes = getConvertedTotal(incomesCommon, amountIncomesCommon, "incomes_common") + getConvertedTotal(incomesIndividual, amountIncomesIndividual, "incomes_individual");
    return Math.max(expenses - incomes, 0);
  }, [isPropertyView, total, rateValue, report, amount, reportE, amountE, reportI, amountI, funds, amountF, incomesCommon, amountIncomesCommon, incomesIndividual, amountIncomesIndividual, getRateForRow]);

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
      // HO-TASK-254: el PDF se arma con una captura de pantalla, así que las
      // reglas de impresión no le aplican; se saltan a mano los mismos
      // elementos que se ocultan al imprimir.
      ignoreElements: (element) => element.classList?.contains("d-print-none"),
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Reportes.pdf");
  };

  const fetchApiShowCurrency = useCallback(async () => {
    if (!params.period_id) return;
    try {
      const response = await showCurrency(paramsCurrency);
      setCurrency(response.data ? response.data : []);
    } catch (error) {
      setCurrency([]);
    }
  }, [params]);

    useEffect(() => {
    fetchApireports();
  }, [fetchApireports]);

  // HO-TASK-247: los subtotales conservan todos sus decimales. Redondear cada
  // uno a 2 antes de sumarlos hacía que "Total a pagar" no coincidiera con la
  // suma de las filas, y en la vista por propietario el error se multiplicaba
  // porque encima cada monto se escala por la alícuota. Los 2 decimales son
  // solo para mostrar: los pone NumberFormat.
  useEffect(() => {
    // Gasto ordinario
    const monto = report.reduce((a, c) => {
      return a + Number(c.amount || 0);
    }, 0);
    setAmount(monto);

    // Gasto extraordinario

    const montoE = reportE.reduce((a, c) => {
      return a + Number(c.amount || 0);
    }, 0);
    setAmountE(montoE);

    // Gasto individual

    const montoI = reportI.reduce((a, c) => {
      return a + Number(c.amount || 0);
    }, 0);
    setAmountI(montoI);

  }, [report, reportE, reportI]);

  useEffect(() => {
    const monto = funds.reduce((a, c) => {
      return a + Number(c.amount || 0);
    }, 0);
    setAmountF(monto);
  }, [funds]);

  useEffect(() => {
    setAmountIncomesCommon(
      incomesCommon.reduce((sum, income) => sum + Number(income.amount || 0), 0)
    );
    setAmountIncomesIndividual(
      incomesIndividual.reduce(
        (sum, income) => sum + Number(income.amount || 0),
        0
      )
    );
  }, [incomesCommon, incomesIndividual]);

  useEffect(() => {
    fetchApiShowCurrency();
  }, [fetchApiShowCurrency]);

  const loadData = () => {
    setUserData({});
    checkUserToken(token)
      // Se guarda el recurso completo, no su campo `data`. `data` es la persona
      // (PeopleResource) y su id es el de la tabla people, no el de la cuenta:
      // el envío al administrador se lo pasaba así al backend, que busca un
      // AuthCredential con ese número y terminaba mandando el correo a la
      // cuenta equivocada (por eso salía la dirección "VIL-14").
      .then((auth) => {
        setUserData(auth || {});
      })
      .catch((error) => setError(error));
  };

  useEffect(() => {
    loadData();
    return () => setUserData({});
    // eslint-disable-next-line
  }, []);

  const fechaEmision = data && data.length > 0 ? data[0]?.created_at : null;
  const fechaFormateada = formatPlanillaDate(planillaDueDate(periodos.period_date, fechaEmision));
  const fechaFormateadaE = formatPlanillaDate(fechaEmision);
  const [modalIsOpenPeriodEmail, setModalIsOpenPeriodEmail] = useState(false);
  const [modalIsOpenAdmin, setModalIsOpenAdmin] = useState(false);
  const [isLoadingAdmin, setIsLoadingAdmin] = useState(false);
  const [autoPaySummary, setAutoPaySummary] = useState(null);

  // El período ya se eligió en el filtro de arriba, así que los modales de
  // envío arrancan con ese mismo período en vez de obligar a seleccionarlo de
  // nuevo (y el botón de enviar queda habilitado de entrada).
  const openModalPeriodEmail = () => {
    if (periodos.period_id) setPeriodId(Number(periodos.period_id));
    setModalIsOpenPeriodEmail(true);
  };

  useEffect(() => {
    if (!modalIsOpenPeriodEmail || !periodId) {
      setAutoPaySummary(null);
      return;
    }
    fetchAutoPaySummary(id, periodId)
      .then((response) => setAutoPaySummary(response?.data ?? null))
      .catch(() => setAutoPaySummary(null));
  }, [modalIsOpenPeriodEmail, periodId, id]);

  const openModalAdmin = () => {
    if (periodos.period_id) setPeriodId(Number(periodos.period_id));
    setModalIsOpenAdmin(true);
  };
  const closeModalAdmin = () => {
    setModalIsOpenAdmin(false);
  };
  const closeModalPeriodEMail = () => {
    setModalIsOpenPeriodEmail(false);
  };

  const handleSendEmail = async (period) => {
    try {
      const response = await sendEmail(id, period, {
        exchangeRate: rateValue,
        exchangeRateDate: appliedRateDate,
        itemsInQuote: showItemsInQuote,
        totalsInQuote: showTotalsInQuote,
      });
      const code = String(response?.code ?? response?.data?.code ?? "").trim();
      const isSuccess = [
        SUCCESS_RESPONSE.OK,
        SUCCESS_RESPONSE.SUCCESFUL,
        SUCCESS_RESPONSE.CREATED,
        SUCCESS_RESPONSE.ADDED_TO_QUEUE,
      ].includes(code);

      if (isSuccess) {
        Toast.fire({
          type: "success",
          title: `Avisos enviados exitosamente.`,
        });
      } else if (code) {
        Toast.fire({
          type: "warning",
          title: `No se pudo enviar el aviso.`,
        });
      }
    } catch (error) {
      console.error(error);
      Toast.fire({
        type: "error",
        title: `No se pudo enviar el aviso.`,
      });
    }
    // Se cierra el modal del período, no `modalIsOpen`, que no lo usa ningún
    // modal. Antes se cerraba ése y el modal real quedaba abierto, lo que se
    // disimulaba con un redirect a la previsualización de planilla.
    closeModalPeriodEMail();
  };

  const handleSendEmailAdmin = async (period) => {
    setIsLoadingAdmin(true);
    try {
      const response = await sendEmailAdmin(id, period, userData.id, {
        exchangeRate: rateValue,
        exchangeRateDate: appliedRateDate,
        itemsInQuote: showItemsInQuote,
        totalsInQuote: showTotalsInQuote,
      });
      const code = String(response?.code ?? response?.data?.code ?? "").trim();
      const isSuccess = [
        SUCCESS_RESPONSE.OK,
        SUCCESS_RESPONSE.SUCCESFUL,
        SUCCESS_RESPONSE.CREATED,
        SUCCESS_RESPONSE.ADDED_TO_QUEUE,
      ].includes(code);

      if (isSuccess) {
        Toast.fire({
          type: "success",
          title: `Avisos enviados exitosamente.`,
        });
      } else if (code) {
        Toast.fire({
          type: "warning",
          title: `No se pudo enviar el aviso.`,
        });
      }
    } catch (error) {
      console.error(error);
      Toast.fire({
        type: "error",
        title: `No se pudo enviar el aviso.`,
      });
    } finally {
      setIsLoadingAdmin(false);
    }
    closeModalAdmin();
  };

  const ButtonSendEmail = () => {
    return (
      <ButtonIcon
        title="Enviar correo electrónico"
        color="falcon-default"
        /*    onClick={onClick} */
        onClick={openModalPeriodEmail}
        icon={faEnvelope}
      >
        Enviar planillas a propietarios
      </ButtonIcon>
    );
  };

  const ButtonSendEmailAdmin = () => {
    return (
      <ButtonIcon
        title="Enviar correo electrónico"
        color="falcon-default"
        className="ml-3"
        /*    onClick={onClick} */
        onClick={openModalAdmin}
        icon={faEnvelope}
      >
        Enviar planillas al administrador
      </ButtonIcon>
    );
  };

  const estimateTotalCell = (row, rate) => {
    const total = row?.total_amount;

    return (
      <td className="align-middle text-right" style={{ width: "15%" }}>
        {total === undefined || total === null ? (
          "-"
        ) : (
          <>
            <span className="d-block font-weight-semi-bold">
              <NumberFormat
                className="text-nowrap"
                displayType="text"
                prefix={`${baseCurrency.symbol} `}
                allowedDecimalSeparators={true}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                value={total}
              />
            </span>
            <QuoteAmount
              value={total}
              convertedValue={row?.total_amount_converted ?? undefined}
              customRate={rate}
            />
          </>
        )}
      </td>
    );
  };

  return (
    <>
      <PageHeader
        title="Planilla de liquidación de gastos"
        titleTag="h2"
        description="Gestiona y administra cada una de tus finanzas."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      {/*    <Alert color="info" className="shadow-sm">
        <Row className="justify-content-between align-items-center d-flex">
          <Col
            xs="auto"
            lg={"auto"}
            md={12}
            className="justify-self-end d-flex justify-content-end align-items-center"
          >
            <Button
              data-testid="condominium-button-chat"
              tag={Link}
              to={`/dashboard/${moduleBase}/${selectedCondominium}/form`}
              color="link"
              size="sm"
              className="pl-0"
            >
              ¿Quieres previsualizar la planilla única de gastos? Dale click
              aqui.
            </Button>
          </Col>
        </Row>
      </Alert> */}
      <Card>
        <FalconCardHeader title="Planilla de liquidación de gastos">
          <Row form className="align-items-end">
            <Col md={5} sm={12} tag={FormGroup} className="mb-2 mb-md-0">
              <Label>Seleccionar período</Label>
              <PeriodSelect
                condominiumId={selectedCondominium}
                value={periodos.period_id}
                onChange={(newId, selectedPeriod) => {
                  setParamsCurrency((prev) => ({
                    ...prev,
                    start_date: selectedPeriod ? selectedPeriod.start_at : "",
                    end_date: selectedPeriod ? selectedPeriod.end_at : "",
                  }));
                  setPeriodos((prev) => ({
                    ...prev,
                    period_id: selectedPeriod ? selectedPeriod.id : "",
                    period_name: selectedPeriod ? selectedPeriod.name : "",
                    period_date: selectedPeriod ? selectedPeriod.end_at : "",
                  }));
                }}
                placeholder="Selecciona un período"
              />
            </Col>
            <Col md={4} sm={12} tag={FormGroup} className="mb-2 mb-md-0">
              <Label>Fecha de la tasa de cambio</Label>
              <Datetime
                value={
                  rateDateInput ? moment(rateDateInput, "YYYY-MM-DD") : ""
                }
                onChange={(picked) => {
                  if (moment.isMoment(picked) && picked.isValid()) {
                    setRateDateInput(picked.format("YYYY-MM-DD"));
                    return;
                  }
                  const parsed = moment(
                    picked,
                    ["DD MMM YYYY", "YYYY-MM-DD"],
                    true
                  );
                  setRateDateInput(
                    parsed.isValid() ? parsed.format("YYYY-MM-DD") : ""
                  );
                }}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
                closeOnSelect
                isValidDate={(current) => !current.isAfter(moment(), "day")}
                inputProps={{ placeholder: "DD MMM YYYY" }}
              />
            </Col>
            <Col md={3} sm={12} className="mb-2 mb-md-0">
              <ButtonIcon
                onClick={() => {
                  setParams((prev) => ({
                    ...prev,
                    period_id: periodos.period_id,
                  }));
                  setAppliedRateDate(rateDateInput || today);
                }}
                className="text-nowrap"
                // Se bloquea mientras se busca para que no se disparen
                // consultas encima de la que ya está corriendo.
                disabled={isBusy}
                icon={isBusy ? faSpinner : faSearch}
                iconClassName={isBusy ? "fa-spin" : ""}
                color="falcon-default"
              >
                {isBusy ? "Buscando..." : "Buscar"}
              </ButtonIcon>
            </Col>
          </Row>
          {/* HO-TASK-246: aplica al momento, sin volver a buscar, porque solo
          cambia cómo se muestran los montos que ya están en pantalla. */}
          {hasConversion && (
            <Row className="mt-3">
              <Col xs={12} className="text-left">
                <CustomInput
                  type="switch"
                  id="showItemsInQuote"
                  data-testid="show-items-in-quote"
                  label={`Mostrar el monto de cada gasto en ${curr.currency.iso}`}
                  checked={showItemsInQuote}
                  onChange={(event) =>
                    setShowItemsInQuote(event.target.checked)
                  }
                />
                <span className="d-block fs--1 text-600">
                  Si lo dejas apagado, la planilla convierte solo los totales.
                  Vale para lo que ves en pantalla, para el PDF que descargas y
                  para las planillas que envíes por correo desde aquí.
                </span>
                <CustomInput
                  type="switch"
                  id="showTotalsInQuote"
                  data-testid="show-totals-in-quote"
                  className="mt-2"
                  label={`Mostrar el monto total en ${curr.currency.iso}`}
                  checked={showTotalsInQuote}
                  onChange={(event) =>
                    setShowTotalsInQuote(event.target.checked)
                  }
                />
                <span className="d-block fs--1 text-600">
                  Si lo apagas, ningún total de la planilla lleva su monto en{" "}
                  {curr.currency.iso}. También vale para el PDF y para los
                  correos que envíes desde aquí.
                </span>
              </Col>
            </Row>
          )}
        </FalconCardHeader>
      </Card>
      {!params.period_id ? (
        // Sin periodo el reporte se dibujaba igual: un bloque en blanco con
        // los totales en cero, y los botones de descargar y enviar por correo
        // ofreciendo algo que todavia no existe.
        <Card className="mb-3">
          <CardBody className="text-center py-6">
            <h5 className="fs-0 text-700 mb-2">
              Todavía no hay nada que mostrar
            </h5>
            <span className="text-600">
              Selecciona un período y pulsa Buscar para ver la planilla de
              liquidación de gastos.
            </span>
          </CardBody>
        </Card>
      ) : (
        <>
      <Card className="mb-3">
        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Descargar reporte</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                onClick={handleDownload}
                disabled={!report}
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                onClick={handlePrint}
                color="falcon-default"
                size="sm"
                icon="print"
                disabled={!report}
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-3">
        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Enviar por correo</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonSendEmail />
              <ButtonSendEmailAdmin />

            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card
        className="mb-3"
        style={{ position: "relative" }}
        innerRef={(e) => {
          reportRef.current = e;
        }}
      >
        {isBusy && (
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.88)",
              borderRadius: "0.375rem",
              zIndex: 10,
            }}
          >
            <Spinner
              color="primary"
              style={{ width: "3rem", height: "3rem", borderWidth: "0.3rem" }}
            />
            <h6 className="mt-3 mb-0 text-600">
              {isSearching
                ? "Buscando la planilla del período..."
                : "Consultando la tasa de cambio..."}
            </h6>
          </div>
        )}
        <CardBody>
          <Nav tabs className="mb-3 d-print-none">
            <NavItem>
              <NavLink
                className={classNames(
                  { active: viewMode === "condominium" },
                  "py-2 px-3"
                )}
                onClick={() => {
                  setViewMode("condominium");
                  setSelectedAliquot(null);
                }}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={faBuilding} className="mr-2" />
                Condominio completo
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classNames(
                  { active: viewMode === "property" },
                  "py-2 px-3"
                )}
                onClick={() => setViewMode("property")}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={faUser} className="mr-2" />
                Por propietario
              </NavLink>
            </NavItem>
          </Nav>

          {viewMode === "property" && (
            <div>
              {selectedAliquot ? (
                <Alert
                  color="info"
                  // mb-3: sin margen abajo el aviso quedaba pegado al
                  // encabezado de la planilla.
                  className="shadow-sm mb-3 d-flex justify-content-between align-items-center d-print-none"
                >
                  <span>
                    Mostrando cuentas de{" "}
                    <strong>
                      {selectedAliquot?.property?.user?.data?.firstname}{" "}
                      {selectedAliquot?.property?.user?.data?.lastname}
                    </strong>
                    {selectedAliquot?.property?.property
                      ? ` · Inmueble: ${selectedAliquot.property.property}`
                      : ""}{" "}
                    · Alícuota: {Number(selectedAliquot.value).toFixed(4)}%
                  </span>
                  <Button
                    color="link"
                    size="sm"
                    // text-nowrap: si no, "Cambiar propietario" se parte en dos
                    // líneas cuando el nombre del propietario es largo.
                    className="p-0 ml-3 text-nowrap"
                    onClick={() => setSelectedAliquot(null)}
                  >
                    Cambiar propietario
                  </Button>
                </Alert>
              ) : (
                <>
                  <Label for="reportPropertySearch">Buscar propietario</Label>
                  <Row form className="mb-3">
                    <Col sm>
                      <Input
                        id="reportPropertySearch"
                        placeholder="Inmueble, nombre, usuario, cédula, teléfono o correo"
                        bsSize="sm"
                        value={propertySearchInput}
                        onChange={(event) => {
                          const value = event.target.value;
                          setPropertySearchInput(value);
                          if (value.trim() === "") handleSearchProperty("");
                        }}
                        onKeyDown={(event) => {
                          if (event.key !== "Enter") return;
                          event.preventDefault();
                          handleSearchProperty(event.currentTarget.value);
                        }}
                      />
                    </Col>
                    <Col xs="auto">
                      <ButtonIcon
                        icon={faSearch}
                        color="falcon-default"
                        size="sm"
                        onClick={() => handleSearchProperty()}
                      >
                        Buscar
                      </ButtonIcon>
                    </Col>
                  </Row>
                  <div style={{ minHeight: "120px" }}>
                    {isLoadingAliquots ? (
                      <Row className="p-4 align-items-center justify-content-center text-center">
                        <Loader padding="py-3" />
                      </Row>
                    ) : (
                      aliquotsList.map((aliquot) => (
                        <SelectPropertyListItem
                          key={aliquot.id}
                          propertyId={aliquot?.property?.id}
                          selected={selectedAliquot?.property?.id}
                          onSelect={() => setSelectedAliquot(aliquot)}
                          dni={aliquot?.property?.user?.data?.dni}
                          username={aliquot?.property?.user?.username}
                          name={`${aliquot?.property?.user?.data?.firstname || ""} ${
                            aliquot?.property?.user?.data?.lastname || ""
                          }`}
                        />
                      ))
                    )}
                    {!isLoadingAliquots && aliquotsList.length === 0 && (
                      <p className="text-muted fs--1 mb-0">
                        No se encontraron propietarios con alícuotas registradas.
                      </p>
                    )}
                  </div>
                  {aliquotsList.length > 0 && (
                    <FullPagination
                      nextPage={aliquotsNextPage}
                      prevPage={aliquotsPreviousPage}
                      goToPage={aliquotsGoToPage}
                      meta={aliquotsMeta}
                      className="shadow-none border-top-0"
                      posText="propietarios"
                      perPage={aliquotsPerPage}
                    />
                  )}
                </>
              )}
            </div>
          )}
          {/* HO-TASK-247: con la planilla ya emitida se muestra la real, con el
          mismo formato y los mismos datos que el PDF del correo. Mientras no
          exista (período sin emitir, o vista del condominio completo) se sigue
          con la previsualización de siempre. */}
          {isPropertyView && isLoadingPlanilla && (
            <Row className="p-4 align-items-center justify-content-center text-center">
              <Loader padding="py-3" />
            </Row>
          )}

          {hasRealPlanilla ? (
            <PropertyPlanillaReport
              planilla={propertyPlanilla}
              logo={dataConfig?.data?.logo}
              baseCurrencySymbol={baseCurrency?.symbol}
              quoteCurrencyIso={curr?.currency?.iso}
              rateValue={Number(propertyPlanilla?.currencyContext?.rate || rateValue || 0)}
              rateDateLabel={
                propertyPlanilla?.currencyContext?.rate_date
                  ? moment(propertyPlanilla.currencyContext.rate_date).format("DD MMM YYYY")
                  : rateDateLabel
              }
              appliedRateDateLabel={appliedRateDateLabel}
              showItemsInQuote={showItemsInQuote}
              showTotalsInQuote={showTotalsInQuote}
              getRateForRow={getRateForRow}
            />
          ) : (
          <>
          {isPropertyView && !isLoadingPlanilla && params.period_id && (
            <Alert color="warning" className="shadow-sm fs--1">
              Este período todavía no tiene una planilla emitida para este
              propietario. Los montos de abajo son una estimación calculada con
              su alícuota, no lo que se le cobró.
            </Alert>
          )}
          <ItemImageTitleSubProperty
            image={dataConfig?.data?.logo}
            title1={"Planilla de liquidación de gastos"}
            titleCondominium={`Condominio: ${condominium}`}
            titleInvoice={"Datos adicionales"}
            condominium={[
              {
                label: "Documento de identificación",
                value: phone || "No disponible",
              },

              { label: "Dirección", value: address },
            ]}
            invoice={[
              {
                label: "Fecha de emisión",
                value: data.length > 0 ? fechaFormateadaE : "No disponible",
              },
              {
                label: "Fecha de vencimiento",
                value: periodos.period_date ? fechaFormateada : "No disponible",
              },
              {
                label: "Período",
                value: periodos.period_name
                  ? periodos.period_name
                  : "Seleccione un período",
              },
              {
                label: "Tasa de cambio",
                value: (
                  <>
                    {isRateLoading ? (
                      "Consultando tasa..."
                    ) : curr?.currency && rateValue > 0 ? (
                      <>
                        <NumberFormat
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={1}
                        />
                        <NumberFormat
                          displayType="text"
                          prefix={" | " + curr?.currency?.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={rateValue}
                        />
                        {rateDateLabel ? ` (${rateDateLabel})` : ""}
                        {rateFallbackNotice && (
                          <span className="d-block text-warning">
                            {rateFallbackNotice}
                          </span>
                        )}
                      </>
                    ) : (
                      "No disponible"
                    )}
                  </>
                ),
              },
              {
                label: "Total a pagar",
                value: (
                  <>
                    <NumberFormat
                      displayType="text"
                      prefix={`${baseCurrency.symbol} `}
                      allowedDecimalSeparators={true}
                      decimalScale={2}
                      fixedDecimalScale
                      thousandSeparator={true}
                      value={total.toFixed(2)}
                    />
                    {showTotalsInQuote && (
                      <NumberFormat
                        displayType="text"
                        prefix={" | " + curr?.currency?.iso + " "}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={convertedTotal}
                      />
                    )}
                  </>
                ),
              },
            ]}
            loading={loadingConfig}
          />

          {isPropertyView && propertyPlanilla?.amounts && (
            <div className="mt-3">
              <PlanillaBalanceTiles
                amounts={propertyPlanilla.amounts}
                renderAmount={(value, valueBs) => (
                  <>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={Number(value || 0)}
                      />
                    </div>
                    {curr?.currency?.iso && rateValue > 0 && showTotalsInQuote && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr.currency.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={
                            valueBs !== undefined && valueBs !== null
                              ? Number(valueBs)
                              : Number(value || 0) * rateValue
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          )}

          {report.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0">Gastos ordinarios</th>
                    {!isPropertyView && <th className="border-0">Proveedor</th>}
                    <th className="border-0">Descripción</th>
                    <th className="border-0" style={{whiteSpace: 'nowrap'}}>Fecha del gasto</th>
                    <th className="border-0 text-right" style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Cuota" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {report.map((cuenta, index) => (
                    <tr key={index}>
                      <td
                        className="align-middle col-3"
                        style={{ width: "30%" }}
                      >
                        {" "}
                        <h6 className="mb-0">
                          {cuenta?.name ? cuenta?.name : cuenta.finance.name}{" "}
                        </h6>
                      </td>
                      {!isPropertyView && (
                        <td className="align-middle" style={{ width: "20%" }}>
                          {" "}
                          {cuenta.provider_name ||
                            cuenta?.finance?.provider_name ||
                            cuenta?.finance?.provider?.name ||
                            "No disponible"}
                        </td>
                      )}
                      <td className="align-middle" style={{ width: "30%" }}>
                        {cuenta?.description
                          ? cuenta?.description
                          : cuenta.finance.description}
                        {/* <p className="mb-0">{cuenta.name}</p> */}
                      </td>

                      <td className="align-middle">
                        {moment(cuenta.expense_date || cuenta.finance?.expired_at).format("DD MMM YYYY")}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={getRateForRow(cuenta)}
                        />
                      </td>

                      {isPropertyView && estimateTotalCell(cuenta, getRateForRow(cuenta))}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={cuenta.amount}
                          />
                        </span>
                        <QuoteAmount
                          value={cuenta.amount}
                          convertedValue={cuenta.amount_converted ?? undefined}
                          customRate={getRateForRow(cuenta)}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={5} className="text-900">Total de gastos ordinarios</th>
                    <td className="align-middle text-right font-weight-semi-bold">
                      <span className="d-block">
                        <NumberFormat
                          className="text-nowrap"
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={amount}
                        />
                      </span>
                      <QuoteAmount value={amount} convertedValue={getConvertedTotal(report, amount, "ordinary")} isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}

          {reportE.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0">Gastos extraordinarios</th>
                    {!isPropertyView && <th className="border-0">Proveedor</th>}
                    <th className="border-0" >Descripción</th>
                    <th className="border-0" style={{whiteSpace: 'nowrap'}}>Fecha del gasto</th>
                    <th className="border-0 text-right"  style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Cuota" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {reportE.map((cuenta, index) => (
                    <tr key={index}>
                      <td
                        className="align-middle col-3"
                        style={{ width: "30%" }}
                      >
                        {" "}
                        <h6 className="mb-0">
                          {cuenta?.name ? cuenta?.name : cuenta.finance.name}{" "}
                        </h6>
                      </td>
                      {!isPropertyView && (
                        <td className="align-middle" style={{ width: "20%" }}>
                          {" "}
                          {cuenta.provider_name ||
                            cuenta?.finance?.provider_name ||
                            cuenta?.finance?.provider?.name ||
                            "No disponible"}
                        </td>
                      )}
                      <td className="align-middle" style={{ width: "30%" }}>
                        {cuenta?.description
                          ? cuenta?.description
                          : cuenta.finance.description}
                        {/* <p className="mb-0">{cuenta.name}</p> */}
                      </td>

                      <td className="align-middle">
                        {moment(cuenta.expense_date || cuenta.finance?.expired_at).format("DD MMM YYYY")}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={getRateForRow(cuenta)}
                        />
                      </td>

                      {isPropertyView && estimateTotalCell(cuenta, getRateForRow(cuenta))}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={cuenta.amount}
                          />
                        </span>
                        <QuoteAmount
                          value={cuenta.amount}
                          convertedValue={cuenta.amount_converted ?? undefined}
                          customRate={getRateForRow(cuenta)}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={5} className="text-900">Total de gastos extraordinarios</th>
                    <td className="align-middle text-right font-weight-semi-bold">
                      <span className="d-block">
                        <NumberFormat
                          className="text-nowrap"
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={amountE}
                        />
                      </span>
                      <QuoteAmount value={amountE} convertedValue={getConvertedTotal(reportE, amountE, "extraordinary")} isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}

          {reportI.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0">Gastos particulares</th>
                    {!isPropertyView && <th className="border-0">Proveedor</th>}
                    <th className="border-0">Descripción</th>
                    <th className="border-0"  style={{whiteSpace: 'nowrap'}}>Fecha del gasto</th>
                    <th className="border-0 text-right"  style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Cuota" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {reportI.map((cuenta, index) => (
                    <tr key={index}>
                      <td
                        className="align-middle col-3"
                        style={{ width: "30%" }}
                      >
                        {" "}
                        <h6 className="mb-0">
                          {cuenta?.name ? cuenta?.name : cuenta.finance.name}{" "}
                        </h6>
                      </td>
                      {!isPropertyView && (
                        <td className="align-middle" style={{ width: "20%" }}>
                          {" "}
                          {cuenta.provider_name ||
                            cuenta?.finance?.provider_name ||
                            cuenta?.finance?.provider?.name ||
                            "No disponible"}
                        </td>
                      )}
                      <td className="align-middle" style={{ width: "30%" }}>
                        {cuenta?.description
                          ? cuenta?.description
                          : cuenta.finance.description}
                      </td>

                      <td className="align-middle">
                        {moment(cuenta.expense_date || cuenta.finance?.expired_at).format("DD MMM YYYY")}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={getRateForRow(cuenta)}
                        />
                      </td>

                      {isPropertyView && estimateTotalCell(cuenta, getRateForRow(cuenta))}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={cuenta.amount}
                          />
                        </span>
                        <QuoteAmount
                          value={cuenta.amount}
                          convertedValue={cuenta.amount_converted ?? undefined}
                          customRate={getRateForRow(cuenta)}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={5} className="text-900">Total de gastos particulares</th>
                    <td className="align-middle text-right font-weight-semi-bold" colSpan={2}>
                      <span className="d-block">
                        <NumberFormat
                          className="text-nowrap"
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={amountI}
                        />
                      </span>
                      <QuoteAmount value={amountI} convertedValue={getConvertedTotal(reportI, amountI, "particular")} isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}

          {funds.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0">Fondos de reserva</th>
                    <th className="border-0">Descripción</th>
                    <th className="border-0"  style={{whiteSpace: 'nowrap'}}>Fecha del gasto</th>
                    <th className="border-0 text-right"  style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Cuota" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {funds.map((cuenta, index) => (
                    <tr key={index}>
                      <td className="align-middle" style={{ width: "50%" }}>
                        {" "}
                        <h6 className="mb-0">{cuenta.name}</h6>
                      </td>
                      <td className="align-middle" style={{ width: "30%" }}>
                        {cuenta.description}
                      </td>

                      <td className="align-middle">
                        {appliedRateDateLabel}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={rateValue || 0}
                        />
                      </td>

                      {isPropertyView && estimateTotalCell(cuenta, rateValue)}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={cuenta.amount}
                          />
                        </span>
                        <QuoteAmount
                          value={cuenta.amount}
                          convertedValue={cuenta.amount_converted ?? undefined}
                          customRate={rateValue}
                        />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={isPropertyView ? 5 : 4} className="text-900">Total fondo de reserva</th>
                    <td className="align-middle text-right font-weight-semi-bold">
                      <span className="d-block">
                        <NumberFormat
                          className="text-nowrap"
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={amountF}
                        />
                      </span>
                      <QuoteAmount value={amountF} convertedValue={sectionBs("funds", Number(amountF) * (rateValue || 0))} isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          {incomesCommon.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0">Ingresos comunes</th>
                    <th className="border-0">Descripción</th>
                    <th className="border-0" style={{whiteSpace: 'nowrap'}}>Fecha del ingreso</th>
                    <th className="border-0 text-right" style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Descuento" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {incomesCommon.map((income) => (
                    <tr key={income.id}>
                      <td className="align-middle" style={{ width: "40%" }}>
                        <h6 className="mb-0">{income.name}</h6>
                      </td>
                      <td className="align-middle" style={{ width: "30%" }}>
                        {income.description}
                      </td>
                      <td className="align-middle">
                        {moment(income.expense_date || income.created_at).format("DD MMM YYYY")}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={getRateForRow(income)}
                        />
                      </td>
                      {isPropertyView && estimateTotalCell(income, getRateForRow(income))}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator
                            value={income.amount}
                          />
                        </span>
                        <QuoteAmount value={income.amount} convertedValue={income.amount_converted ?? undefined} customRate={getRateForRow(income)} />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={isPropertyView ? 5 : 4} className="text-900">
                      Total ingresos comunes (se descuenta del total a pagar)
                    </th>
                    <td className="align-middle text-right font-weight-semi-bold">
                      <NumberFormat
                        className="text-nowrap"
                        displayType="text"
                        prefix={`- ${baseCurrency.symbol} `}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator
                        value={amountIncomesCommon}
                      />
                      <QuoteAmount value={amountIncomesCommon} convertedValue={getConvertedTotal(incomesCommon, amountIncomesCommon, "incomes_common")} negative isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}

          {incomesIndividual.length > 0 && (
            <div className="table-responsive mt-4 fs--1">
              <Table striped className="border-bottom">
                <thead>
                  <tr>
                    <th className="border-0 col-3">Ingresos individuales</th>
                    <th className="border-0">Descripción</th>
                    <th className="border-0" style={{whiteSpace: 'nowrap'}}>Fecha del ingreso</th>
                    <th className="border-0 text-right" style={{whiteSpace: 'nowrap'}}>Tasa del día</th>
                    {isPropertyView && <th className="border-0 text-right">Monto</th>}
                    <th className="border-0 text-right">{isPropertyView ? "Descuento" : "Monto"}</th>
                  </tr>
                </thead>
                <tbody>
                  {incomesIndividual.map((income) => (
                    <tr key={income.id}>
                      <td className="align-middle" style={{ width: "40%" }}>
                        <h6 className="mb-0">{income.name}</h6>
                      </td>
                      <td className="align-middle" style={{ width: "30%" }}>
                        {income.description}
                      </td>
                      <td className="align-middle">
                        {moment(income.expense_date || income.created_at).format("DD MMM YYYY")}
                      </td>
                      <td className="align-middle text-right text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${curr?.currency?.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={getRateForRow(income)}
                        />
                      </td>
                      {isPropertyView && estimateTotalCell(income, getRateForRow(income))}
                      <td
                        className="align-middle text-right"
                        style={{ width: "20%" }}
                      >
                        <span className="d-block font-weight-semi-bold">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator
                            value={income.amount}
                          />
                        </span>
                        <QuoteAmount value={income.amount} convertedValue={income.amount_converted ?? undefined} customRate={getRateForRow(income)} />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <th colSpan={isPropertyView ? 5 : 4} className="text-900">
                      Total ingresos individuales (se descuenta del total a pagar)
                    </th>
                    <td className="align-middle text-right font-weight-semi-bold">
                      <NumberFormat
                        className="text-nowrap"
                        displayType="text"
                        prefix={`- ${baseCurrency.symbol} `}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator
                        value={amountIncomesIndividual}
                      />
                      <QuoteAmount value={amountIncomesIndividual} convertedValue={getConvertedTotal(incomesIndividual, amountIncomesIndividual, "incomes_individual")} negative isTotal />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          <div className="table-responsive mt-4 fs--1">
            <Table striped className="border-bottom">
              <thead>
                <tr>
                  <th className="border-0 align-top" colSpan={1}>
                    {isPropertyView
                      ? `Total a pagar propietario (${selectedAliquot?.property?.user?.data?.firstname || ""} ${
                          selectedAliquot?.property?.user?.data?.lastname || ""
                        })`
                      : "Total gastos condominio"}
                    {isPropertyView && hasConversion && showTotalsInQuote && (
                      <span className="d-block text-600 fs--1 font-weight-normal mt-1">
                        El monto total a pagar en bolívares es calculado en base a la tasa de cambio del día {appliedRateDateLabel}
                      </span>
                    )}
                  </th>
                  <th className="border-0 align-top text-right font-weight-semi-bold">
                    <span className="d-block">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={total.toFixed(2)}
                      />
                    </span>
                    {showTotalsInQuote && (
                      <span className="d-block text-700 fs--2 text-nowrap">
                        <NumberFormat
                          className="text-right"
                          displayType="text"
                          allowedDecimalSeparators={true}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={curr?.currency?.iso + " "}
                          value={convertedTotal}
                        />
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
            </Table>
            {!isPropertyView && chargedToOwners !== null && Math.abs(Number(aliquotDifference || 0)) >= 0.005 && (
              <Table striped className="border-bottom fs--1">
                <tbody>
                  {/* <tr>
                    <th className="border-0">Cobrado a los propietarios</th>
                    <th className="border-0 text-right font-weight-semi-bold text-nowrap">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={chargedToOwners}
                      />
                    </th>
                  </tr> */}
                  {Math.abs(Number(aliquotDifference || 0)) >= 0.005 && (
                    <tr>
                      <th className="border-0">
                        Diferencia por alícuotas
                        <span className="d-block text-600 fs--1 font-weight-normal mt-1">
                          {`Las alícuotas de las unidades suman ${Number(aliquotsSum || 0).toLocaleString("es-VE", { maximumFractionDigits: 4 })} %. Cada propietario paga su alícuota de cada gasto, así que lo cobrado se aparta de los gastos del período en esta cantidad.`}
                        </span>
                      </th>
                      <th className="border-0 text-right font-weight-semi-bold text-nowrap">
                        <NumberFormat
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={aliquotDifference}
                        />
                      </th>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
            {/* El logo y la nota del condominio son decorativos: mientras
            cargan no se muestra nada. Antes había acá un Spinner sin centrar
            que aparecía pegado a la izquierda, y se veía como un segundo
            cargador al lado del de la búsqueda. */}
            {!loadingConfig && (
              <div className="text-start text-muted mt-3 pt-1 mb-0">
                <Logo
                  to={null}
                  styleImage={{
                    width: "100px",
                  }}
                  className={"mb-2"}
                />
                <div className="mb-0">
                  {(periodNote ?? dataConfig?.data?.note) !== "" && (
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      className="mr-2"
                      size="sm"
                    />
                  )}
                  <pre
                    style={{
                      fontFamily: "Open Sans",
                      fontSize: ".83333rem",
                      color: "#5e6e82",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {periodNote ?? dataConfig?.data?.note}
                  </pre>
                </div>
              </div>
            )}
          </div>
          </>
          )}
        </CardBody>
      </Card>
        </>
      )}
      <Modal
        isOpen={modalIsOpenPeriodEmail}
        contentLabel="Modal de cobro de gastos"
      >
        <Card style={{ padding: "20px" }}>
          <ModalHeader>Enviar avisos de cobro</ModalHeader>
          <ModalBody>
            <Alert color="info" className="shadow-sm">
              <h5 className="alert-heading text-center">
                INFORMACIÓN IMPORTANTE
              </h5>

              <p className="fs--1">
                Si deseas gestionar los períodos solo necesitas dirigirte al{" "}
                <Link
                  to={{
                    pathname: `/dashboard/periods`,
                  }}
                >
                  módulo de períodos
                </Link>
                , donde encontrarás la opción para crear nuevos períodos.
              </p>
            </Alert>
            {autoPaySummary?.properties > 0 && (
              <Alert color="success" className="shadow-sm mb-0">
                <p className="fs--1 mb-0">
                  <strong>Pagadas con saldo a favor:</strong> al emitir este
                  período se{" "}
                  {autoPaySummary.properties === 1
                    ? "pagó con su saldo a favor la planilla de"
                    : "pagaron con su saldo a favor las planillas de"}{" "}
                  <strong>
                    {autoPaySummary.properties}{" "}
                    {autoPaySummary.properties === 1 ? "inmueble" : "inmuebles"}
                  </strong>{" "}
                  por{" "}
                  <strong>
                    <NumberFormat
                      className="text-nowrap"
                      displayType="text"
                      prefix={`${baseCurrency?.symbol ?? "$"} `}
                      decimalScale={2}
                      fixedDecimalScale
                      thousandSeparator
                      value={autoPaySummary.amount}
                    />
                  </strong>
                  . Su correo dirá lo que pagó el saldo.
                </p>
              </Alert>
            )}
          </ModalBody>

          <Label for="period_id">Seleccionar período</Label>
          <Row form className="mb-3">
            <Col sm tag={FormGroup}>
              <PeriodSelect
                inputId="period_id"
                condominiumId={selectedCondominium}
                value={periodId}
                onChange={(newId) => setPeriodId(newId ? Number(newId) : undefined)}
                placeholder="Selecciona un período"
              />
            </Col>
          </Row>
          <ModalFooter>
            <Button onClick={closeModalPeriodEMail} icon={faTimes}>
              Cancelar
            </Button>
            <Button
              data-testid="submit-button"
              color="primary"
              type="submit"
              disabled={!periodId}
              onClick={() => handleSendEmail(periodId)}
            >
              {" "}
              Sí, enviar avisos de cobro
            </Button>
          </ModalFooter>
        </Card>
      </Modal>{" "}
      <Modal isOpen={modalIsOpenAdmin} contentLabel="Modal de cobro de gastos">
        <Card style={{ padding: "20px" }}>
          <ModalHeader>Enviar avisos de cobro al administrador</ModalHeader>
          <ModalBody>
            <Alert color="info" className="shadow-sm">
              <h5 className="alert-heading text-center">
                INFORMACIÓN IMPORTANTE
              </h5>

              <p className="fs--1">
                Si deseas gestionar los períodos solo necesitas dirigirte al{" "}
                <Link
                  to={{
                    pathname: `/dashboard/periods`,
                  }}
                >
                  módulo de períodos
                </Link>
                , donde encontrarás la opción para crear nuevos períodos.
              </p>
            </Alert>
          </ModalBody>

          <Label for="period_id">Seleccionar período</Label>
          <Row form className="mb-3">
            <Col sm tag={FormGroup}>
              <PeriodSelect
                inputId="period_id"
                condominiumId={selectedCondominium}
                value={periodId}
                onChange={(newId) => setPeriodId(newId ? Number(newId) : undefined)}
                placeholder="Selecciona un período"
              />
            </Col>
          </Row>
          <ModalFooter>
            <Button
              onClick={closeModalAdmin}
              icon={faTimes}
              disabled={isLoadingAdmin}
            >
              Cancelar
            </Button>
            <Button
              data-testid="submit-button"
              color="primary"
              type="submit"
              disabled={!periodId || isLoadingAdmin}
              onClick={() => handleSendEmailAdmin(periodId)}
            >
              {isLoadingAdmin ? (
                <>
                  <Spinner size="sm" /> Enviando...
                </>
              ) : (
                "Sí, enviar avisos de cobro"
              )}
            </Button>
          </ModalFooter>
        </Card>
      </Modal>
    </>
  );
};

Reports.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(Reports);
